import { Component, EventEmitter, Input, Output } from "@angular/core"

import { LexTranslateService } from "@app/core/services/lex-translate.service"

@Component({
  selector: "seb-buttons-form-completion",
  templateUrl: "./buttons-form-completion.component.html",
  styleUrls: ["./buttons-form-completion.component.css"],
})
export class ButtonsFormCompletionComponent {
  @Input() canShowSaveBtn: boolean = true
  @Input() btnSaveDisabled: boolean
  @Input() resquestFinalized: boolean
  @Input() loading = false

  @Output() clickBtnCancel = new EventEmitter()
  @Output() clickBtnSave = new EventEmitter()

  constructor(public lextranslate: LexTranslateService) {}

  onClickBtnSave() {
    this.clickBtnSave.emit()
  }

  onClickBtnCancel() {
    this.clickBtnCancel.emit()
  }

  get btnSaveLabel() {
    return this.resquestFinalized
      ? this.lextranslate.i18n["306fa50d-038a-4dea-8a2f-94254412f0da"]
      : this.lextranslate.i18n["fab28818-b71d-4fab-a8fd-fc3842bfde3e"]
  }

  get canDisable() {
    return this.btnSaveDisabled || !this.resquestFinalized || this.loading
  }
}
